import { addEventEntry, addDataLayerEntry } from '@printdeal/data-layer-manager';

enum LoginCategories {
  LOGIN_FORM = 'login_form',
  LOST_PASSWORD_FORM = 'lost_password_form',
}

enum LoginEvents {
  LOGIN_INTERACTION = 'login_interaction',
  LOST_PASSWORD_REQUEST = 'lost_password_request',
  LOGIN_MODAL_SHOW = 'login_modal_show',
  LOGIN_MODAL_TOGGLE = 'login_modal_toggle',
}

export const dispatchDataLayerEventOnLostPasswordClick = (
  linkLocation:string | undefined = '',
  eventLabel?:string,
) => {
  // GA4
  addDataLayerEntry(LoginEvents.LOGIN_INTERACTION, {
    action: `lost_password_link_click${linkLocation ? `_${linkLocation}` : ''}`,
    eventLabel,
  });

  // GA3
  addEventEntry({
    eventCategory: LoginCategories.LOGIN_FORM,
    eventAction: `lost_password_link_click${linkLocation ? `_${linkLocation}` : ''}`,
    eventLabel,
  });
};

export const dispatchDataLayerEventOnLostPasswordRequest = () => {
  // GA4
  addDataLayerEntry(LoginEvents.LOST_PASSWORD_REQUEST);

  // GA3
  addEventEntry({
    eventCategory: LoginCategories.LOST_PASSWORD_FORM,
    eventAction: 'lost_password_request',
  });
};

export const dispatchDataLayerEventLoginError = (errorName: string) => {
  // GA4
  addDataLayerEntry(LoginEvents.LOGIN_INTERACTION, {
    action: `login_error - ${errorName}`,
  });

  // GA3
  addEventEntry({
    eventCategory: LoginCategories.LOGIN_FORM,
    eventAction: `login_error - ${errorName}`,
    eventNonInteraction: false,
  });
};

export const dispatchDataLayerEventLoginModal = (url: string) => {
  // GA4
  addDataLayerEntry(LoginEvents.LOGIN_MODAL_SHOW, {
    page_url: url,
  });

  // GA3
  addEventEntry({
    eventCategory: LoginCategories.LOGIN_FORM,
    eventAction: 'login_modal_show',
    eventLabel: JSON.stringify({ page_url: url, element: 'loginButton' }),
  });
};

export const dispatchDataLayerEventLoginModalToggle = (url: string, showModal: boolean) => {
  // GA4
  addDataLayerEntry(LoginEvents.LOGIN_MODAL_TOGGLE, {
    page_url: url,
    show_modal: showModal,
  });

  // GA3
  addEventEntry({
    eventCategory: LoginCategories.LOGIN_FORM,
    eventAction: 'login_modal_show',
    eventLabel: JSON.stringify({ page_url: url, element: 'loginModal', show_modal: showModal }),
  });
};
